var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-table',{ref:"comp_table",attrs:{"title":"供应商","columns":_vm.columns,"table-api":_vm.tableApi,"operate":_vm.getTableOperate}})}
var staticRenderFns = []

export { render, staticRenderFns }